import axios from 'axios';

export default class PeopleService {
  constructor() {
    this.init();
  }

  public init() {}

  getNetworkChart(title: string, language: string) {
    return axios.get('/api/people/getNetworkChart', {
      params: {
        title: title,
        language: language,
      },
    });
  }

  getPeopleAndCompany(peopleAndCompany: any) {
    return axios.post('/api/people/company', peopleAndCompany);
  }

  getMarketName(code: string) {
    return axios.get('/api/people/market/name?code=' + code);
  }

  public getEntityInfo(peopleAndCompany: any) {
    return axios.post('/api/people/get/entity', peopleAndCompany);
  }

  public getPeopleDocInfo(connectomeId: string, page: number, size: number, orderBy: string, sortDirection: string, isGetStock: boolean) {
    return axios.get('api/people/' + connectomeId, {
      params: {
        page: page,
        size: size,
        orderBy: orderBy,
        sortDirection: sortDirection,
        isGetStock: isGetStock,
      },
    });
  }

  // public findByConnectomeId(connectomeId: string, pageable?, isGetStock?) {
  //   const req = {
  //     page: pageable && pageable.page ? pageable.page - 1 : 0,
  //     size: pageable && pageable.size ? pageable.size : 10,
  //     sort: pageable && pageable.sort ? pageable.sort : ['id,desc'],
  //   };
  //   const lang = localStorage.getItem('currentLanguage') || 'en';
  //   return axios.get('api/people/' + connectomeId + '?' + buildPaginationQueryOpts(req), {
  //     params: {
  //       isGetStock: true,
  //       lang: lang,
  //     },
  //   });
  // }

  hiddenPeople(id, title, type, lang, deleted) {
    return axios.get('api/people/hidden/' + id, {
      params: {
        title: title,
        type: type,
        lang: lang,
        deleted: deleted,
      },
    });
  }
}
